/**
 * Script para verificar las categorías en la base de datos
 */

export const checkCategories = async () => {
  try {
    console.log('🔍 Verificando categorías...');
    
    // Verificar si window.auth está disponible
    if (!window.auth) {
      console.error('❌ window.auth no está disponible');
      return;
    }

    const { getAuth } = window.auth;
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      console.error('❌ Usuario no autenticado');
      return;
    }

    console.log('✅ Usuario autenticado:', user.uid);

    // Obtener categorías usando el servicio optimizado
    const optimizedService = (await import('../services/optimizedInventoryService')).default;
    const categories = await optimizedService.getCategories();
    
    console.log('📊 Categorías encontradas:', categories.length);
    console.log('📋 Lista de categorías:', categories);

    if (categories.length === 0) {
      console.log('⚠️ No hay categorías. Creando categorías de prueba...');
      if ((window as any).createStandardizedCategories) {
        await (window as any).createStandardizedCategories();
        
        // Verificar nuevamente
        const newCategories = await optimizedService.getCategories();
        console.log('📊 Categorías después de crear:', newCategories.length);
        console.log('📋 Nueva lista:', newCategories);
      } else {
        console.log('❌ Función createStandardizedCategories no disponible');
      }
    }

  } catch (error) {
    console.error('❌ Error verificando categorías:', error);
  }
};

// Hacer disponible en consola
if (typeof window !== 'undefined') {
  (window as any).checkCategories = checkCategories;
}
